/**
 * One-time native shell setup: status bar, splash screen, and the Android
 * hardware back button.
 *
 * Every call is a no-op on the web, so index.js can invoke this unconditionally.
 * Plugins are imported lazily — pulling the native bridges into the browser
 * bundle costs bytes no web visitor ever uses.
 */

import { isNative } from './native';

export default async function initNativeShell() {
  if (!isNative()) return;

  const [{ StatusBar, Style }, { SplashScreen }, { App }] = await Promise.all([
    import('@capacitor/status-bar'),
    import('@capacitor/splash-screen'),
    import('@capacitor/app'),
  ]);

  try {
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#DC143C' });
  } catch {
    // Status bar styling is cosmetic and unsupported on some OEM skins.
  }

  // The Android back button defaults to "exit the app" on every screen, which
  // discards navigation history the user expects to walk back through. Only
  // exit once there is nothing left to pop.
  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack && window.history.length > 1) {
      window.history.back();
    } else {
      App.exitApp();
    }
  });

  try {
    await SplashScreen.hide();
  } catch {
    // Already hidden by launchAutoHide.
  }
}
